import CMSAPI from "../../../../services/api/contentManagmentApi";
const { getAbout, updateAbout } = new CMSAPI();
export default {
  data() {
    return {
      about: {},
    };
  },
  methods: {
    handleFormSubmit,
  },
  beforeMount() {
    getAbout().then((response) => {
      this.about = response.data[0];
    });
  },
};
function handleFormSubmit() {
  updateAbout({
    view_components: [
      {
        attributes: {
          title: this.about.title,
          copy: this.about.copy,
        },
        component_type: "ABOUT",
        ordinal: 1,
      },
    ],
  })
    .then(() => this.$swal("Success: About Saved"))
    .catch((error) =>
      error.response
        ? this.$swal("Attention", error.response.data.error_message)
        : this.$logger.notify(new Error(error))
    );
}
